// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import './App.css';

const App = () => (
  <Router>
    <div className="app-container">
    <header className="app-header">
        <h1>My Journal</h1>
        <p>Capture your memories, one entry at a time.</p>
      </header>
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/journal/:id" element={<Home isFullScreenReader={true}/>} />
        </Routes>
      </main>
      <footer className="app-footer">
        <p>© {new Date().getFullYear()} My Journal. All rights reserved.</p>
        <p>Made with ❤️ for memory keepers.</p>
      </footer>
    </div>
  </Router>
);

export default App;